import { Box, Container, Typography, Button } from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';

export default function Contact() {
  return (
    <Box sx={{ py: 10 }}>
      <Container maxWidth="sm">
        <Box sx={{ textAlign: 'center', mb: 8 }}>
          <Typography variant="overline" sx={{ color: 'primary.main', letterSpacing: 4, fontWeight: 700 }}>
            Contact
          </Typography>
          <Typography variant="h2" sx={{ mt: 2, mb: 3, fontSize: { xs: '2rem', md: '2.8rem' } }}>
            お問い合わせ
          </Typography>
          <Typography color="text.secondary" sx={{ lineHeight: 1.9 }}>
            サービスに関するご質問、お見積もり、ご相談など、<br />
            お気軽にお問い合わせください。
          </Typography>
        </Box>

        <Box
          sx={{
            border: '1px solid rgba(255,255,255,0.08)',
            borderRadius: 3,
            p: 6,
            textAlign: 'center',
            background: 'radial-gradient(ellipse at center, rgba(0,229,255,0.04) 0%, transparent 70%)',
          }}
        >
          <EmailIcon sx={{ fontSize: 56, color: 'primary.main', mb: 3 }} />
          <Typography variant="h5" sx={{ mb: 2, fontWeight: 700 }}>
            メールでのお問い合わせ
          </Typography>
          <Typography color="text.secondary" sx={{ mb: 4, lineHeight: 1.8 }}>
            下記メールアドレスまでお気軽にご連絡ください。<br />
            通常2営業日以内にご返信いたします。
          </Typography>
          <Button
            variant="contained"
            size="large"
            startIcon={<EmailIcon />}
            href="mailto:info@takoshilabo.co.jp"
            sx={{ px: 5, py: 1.8, fontWeight: 700, fontSize: '1rem' }}
          >
            メールを送る
          </Button>
        </Box>
      </Container>
    </Box>
  );
}
